// Module
var code = "<div class=\"bIndeterminateCheckbox\" ng-class=\"{'has-state': bIndeterminateCheckbox.hasState()}\" ng-click=\"bIndeterminateCheckbox.changeState()\"> <span ng-if=\"bIndeterminateCheckbox.ngModel\" class=\"checkmarkIcon\"></span> <span ng-if=\"bIndeterminateCheckbox.ngModel === null\" class=\"indeterminate\"></span> </div> ";
// Exports
module.exports = code;